import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { SupportService } from "../../services/support-service";
import { Router } from "@angular/router";
import { AppService } from "src/app/services/app.service";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"],
})
export class SidemenuComponent implements OnInit {
  @Output() sidemenuToggle = new EventEmitter<boolean>();

  showhideSideMenu = false;
  testCenterName: any = "";
  stateName: any = "";
  tcCode: any = "";
  routervalue: any = null;
  usertype: any = "";
  subscriptionstatus = false;
  accessManagement: any = [];
  accessManagements: any = [];

  technicainroutervalue = "";
  schedplanMenu = "";
  dashboardMenu = {
    patientappointmentmenu: false,
    doctorappointmentmenu: false,
    schduleappointmentmenu: false,
    technicianVacationtmenu: false,
    technicianappointmentmenu: false,
    icappointmentmenu: false,
    analysisappointmentmenu: false,
    billingappointmentmenu: false,
    reviewappointmentmenu: false,
    bidequipmentappointmentmenu: false,
    serviceappointmentmenu: false,
    hireappointmentmenu: false,
    reportmenu: false,
    creditCardMenu: false,
  };
  constructor(
    private supportService: SupportService,
    private router: Router,
    private appservice: AppService
  ) {}

  ngOnInit() {
    this.supportService.subscriptionstatus.subscribe((res) => {
      this.subscriptionstatus =
        localStorage.getItem("subscriptionflag") &&
        localStorage.getItem("subscriptionflag") === "true"
          ? true
          : false;
    });

    this.usertype = sessionStorage.getItem("usertype");

    if (localStorage.getItem("testCode") !== null) {
      this.tcCode = localStorage.getItem("testCode").toString();
    }

    if (localStorage.getItem("testCenterName") !== null) {
      this.testCenterName = localStorage.getItem("testCenterName");
    }

    this.getAccessManagement();

    this.supportService.testCenterName.subscribe((res) => {
      this.testCenterName = res;
    });

    this.supportService.stateName.subscribe((res) => {
      this.stateName = res;
    });
    this.supportService.sidemenuname.subscribe((res) => {
      if (res) {
        const urlsplit = res.split("/");
        this.changeURL(urlsplit[2]);
      } else {
        setTimeout(() => {
          if (this.router.url) {
            const urlsplit = this.router.url.split("/");
            this.changeURL(urlsplit[2]);
          }
        }, 1000);
      }
    });
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }
  getAccessManagement() {
    this.appservice.getFrontDeskAccessManagement().subscribe((res) => {
      if (res && res["entity"] && res["entity"].length > 0) {
        this.accessManagement = res["entity"];
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy =
            res["entity"][index]["accessManagement"]["accessType"];
          this.accessManagements[index] = res["entity"][index];
          this.accessManagements[index].groupBy = groupBy;
        }
        this.accessManagement = this.groupBy(this.accessManagements, "groupBy");
        for (let index = 0; index < this.accessManagement.length; index++) {
          this.accessManagement[index].value.sort(
            (a, b) =>
              parseFloat(a.accessManagement.subMenuId) -
              parseFloat(b.accessManagement.subMenuId)
          );
        }

        localStorage.setItem(
          "accessmanagement",
          JSON.stringify(this.accessManagement)
        );

        this.setaccessmanagement(this.accessManagement);
      } else {
        this.accessManagement = [];
      }
    });
  }

  setaccessmanagement(access) {
    for (let i = 0; i < access.length; i++) {
      if (access[i].value.length > 0 && access[i].key === "Operations") {
        for (let j = 0; j < access[i].value.length; j++) {
          if (sessionStorage.getItem("usertype") === "2") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Schedule Appointments"
            ) {
              this.dashboardMenu.schduleappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Patient Information"
            ) {
              this.dashboardMenu.patientappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Doctor's Information"
            ) {
              this.dashboardMenu.doctorappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
                "Technician Schedule" &&
              !this.technicainroutervalue
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                  "Technician Schedule" &&
                access[i].value[j].admin
              ) {
                this.technicainroutervalue = "technician-schedule";
              } else if (
                access[i].value[j].accessManagement.subMenu ===
                  "Technician Vacation" &&
                access[i].value[j].admin
              ) {
                this.technicainroutervalue = "technician-schedule";
              }
            }
          } else if (sessionStorage.getItem("usertype") === "3") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Schedule Appointments"
            ) {
              this.dashboardMenu.schduleappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Patient Information"
            ) {
              this.dashboardMenu.patientappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Doctor's Information"
            ) {
              this.dashboardMenu.doctorappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
                "Technician Schedule" &&
              !this.technicainroutervalue
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                  "Technician Schedule" &&
                access[i].value[j].frontDesk
              ) {
                this.technicainroutervalue = "technician-schedule";
              } else if (
                access[i].value[j].accessManagement.subMenu ===
                  "Technician Vacation" &&
                access[i].value[j].frontDesk
              ) {
                this.technicainroutervalue = "vacation-management";
              }
            }
          }
        }
      }

      if (access[i].value.length > 0 && access[i].key === "Admin") {
        for (let j = 0; j < access[i].value.length; j++) {
          if (sessionStorage.getItem("usertype") === "2") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
                "Imaging Center Profile" &&
              !this.routervalue
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                  "Basic Information" &&
                access[i].value[j].admin
              ) {
                this.routervalue = "basicinfo";
              } else if (
                access[i].value[j].admin &&
                access[i].value[j].accessManagement.subMenu === "Equipments"
              ) {
                this.routervalue = "equipments";
              } else if (
                access[i].value[j].admin &&
                access[i].value[j].accessManagement.subMenu === "Procedures"
              ) {
                this.routervalue = "procedure";
              } else if (
                access[i].value[j].admin &&
                access[i].value[j].accessManagement.subMenu === "Insurance"
              ) {
                this.routervalue = "insurance";
              } else if (
                access[i].value[j].admin &&
                access[i].value[j].accessManagement.subMenu === "Front Desk"
              ) {
                this.routervalue = "front-desk";
              } else if (
                access[i].value[j].admin &&
                access[i].value[j].accessManagement.subMenu ===
                  "Medical Questions"
              ) {
                this.routervalue = "medical-questions";
              } else if (
                access[i].value[j].admin &&
                access[i].value[j].accessManagement.subMenu ===
                  "Access Management"
              ) {
                this.routervalue = "access-management";
              }
            }

            if (access[i].value[j].accessManagement.subMenu === "Credit Card") {
              this.dashboardMenu.creditCardMenu = access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Analysis"
            ) {
              this.dashboardMenu.analysisappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement === "Billing"
            ) {
              this.dashboardMenu.billingappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement === "Reviews"
            ) {
              this.dashboardMenu.reviewappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement === "Reports"
            ) {
              this.dashboardMenu.reportmenu = access[i].value[j].admin;
            }
          } else if (sessionStorage.getItem("usertype") === "3") {
            if (!this.routervalue) {
              if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu ===
                  "Basic Information"
              ) {
                this.routervalue = "basicinfo";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu === "Equipments"
              ) {
                this.routervalue = "equipments";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu === "Procedures"
              ) {
                this.routervalue = "procedure";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu === "Insurance"
              ) {
                this.routervalue = "insurance";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu === "Technicians"
              ) {
                this.routervalue = "technician";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu === "Front Desk"
              ) {
                this.routervalue = "front-desk";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu ===
                  "Medical Questions"
              ) {
                this.routervalue = "medical-questions";
              } else if (
                access[i].value[j].frontDesk &&
                access[i].value[j].accessManagement.subMenu ===
                  "Access Management"
              ) {
                this.routervalue = "access-management";
              }
            }

            if (access[i].value[j].accessManagement.subMenu === "Credit Card") {
              this.dashboardMenu.creditCardMenu = access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Analysis"
            ) {
              this.dashboardMenu.analysisappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement === "Billing"
            ) {
              this.dashboardMenu.billingappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement === "Reviews"
            ) {
              this.dashboardMenu.reviewappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement === "Reports"
            ) {
              this.dashboardMenu.reportmenu = access[i].value[j].frontDesk;
            }
          }
        }
      }

      if (access[i].value.length > 0 && access[i].key === "Other") {
        for (let j = 0; j < access[i].value.length; j++) {
          if (sessionStorage.getItem("usertype") === "2") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Buy and Bid Equipments"
            ) {
              this.dashboardMenu.bidequipmentappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Service and Maintenance"
            ) {
              this.dashboardMenu.serviceappointmentmenu =
                access[i].value[j].admin;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Hiring Technicians"
            ) {
              this.dashboardMenu.hireappointmentmenu = access[i].value[j].admin;
            }
          } else if (sessionStorage.getItem("usertype") === "3") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Buy and Bid Equipments"
            ) {
              this.dashboardMenu.bidequipmentappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Service and Maintenance"
            ) {
              this.dashboardMenu.serviceappointmentmenu =
                access[i].value[j].frontDesk;
            }
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Hiring Technicians"
            ) {
              this.dashboardMenu.hireappointmentmenu =
                access[i].value[j].frontDesk;
            }
          }
        }
      }

      if (i + 1 === access.length) {
        if (this.dashboardMenu.creditCardMenu === true) {
          if (sessionStorage.getItem("usertype") === "3") {
            this.schedplanMenu = "credit-card";
          } else {
            this.schedplanMenu = "plan-subscription";
          }
        } else if (this.dashboardMenu.billingappointmentmenu === true) {
          this.schedplanMenu = "billing-summary";
        }
      }
    }
  }

  currentURL = "";

  changeURL(type) {
    sessionStorage.setItem("type", type);
    if (localStorage.getItem("accesstoken")) {
      if (
        type === "basicinfo" ||
        type === "equipments" ||
        type === "procedure" ||
        type === "insurance" ||
        type === "profile-photos" ||
        type === "technician" ||
        type === "front-desk" ||
        type === "medical-questions" ||
        type === "access-management" ||
        type === "time-slot-settings"
      ) {
        this.supportService.headerSubLittle.next("Imaging Center Profile");
        this.currentURL = "basicinfo";
        sessionStorage.setItem("fromMessagecentre", "false");
      } else if (type === "vacation-management") {
        this.supportService.headerSubLittle.next("Technologist Management");
        sessionStorage.setItem("fromMessagecentre", "false");
        sessionStorage.setItem("fromMessagecentre", "false");
      } else if (
        type === "schedule-appointment" ||
        type === "check-in-patient" ||
        type === "cancel-noshow" ||
        type === "waiting-list-history"
      ) {
        this.supportService.headerSubLittle.next("Scheduling Appointment");
        this.currentURL = "schedule-appointment";
        sessionStorage.setItem("fromMessagecentre", "false");
      } else if (
        type === "plan-subscription" ||
        type === "credit-card" ||
        type === "billing-summary" ||
        type === "billing-reports" ||
        type === "hold-or-cancel"
      ) {
        this.supportService.headerSubLittle.next("SchedMed Plans");
        this.currentURL = "schedule-plan";
        sessionStorage.setItem("fromMessagecentre", "false");
      } else if (
        type === "patient-info" ||
        type === "schedmed-patient" ||
        type === "imaging-center-patients" ||
        type === "authorization-status"
      ) {
        this.supportService.headerSubLittle.next("Patient Information");
        this.currentURL = "patient-info";
        sessionStorage.setItem("fromMessagecentre", "false");
      } else if (type === "physician-information") {
        this.supportService.headerSubLittle.next("Physician Information");
        this.currentURL = type;
        sessionStorage.setItem("fromMessagecentre", "false");
  
        sessionStorage.setItem("fromMessagecentre", "false");
      } else if (type === "patient-review") {
        this.supportService.headerSubLittle.next("Review");
        sessionStorage.setItem("fromMessagecentre", "false");
  
        this.currentURL = type;
      } else if (
        type === "analysis-appointments" ||
        type === "utilization" ||
        type === "equipment-breakdown" ||
        type === "calls-using-schedmed"
      ) {
        this.supportService.headerSubLittle.next("Analysis");
        sessionStorage.setItem("fromMessagecentre", "false");
  
        this.currentURL = "analysis-appointments";
      } else if (type === "cancel-appointments") {
        sessionStorage.setItem("fromMessagecentre", "false");
  
        this.supportService.headerSubLittle.next("Cancel/Block Appointments");
        this.currentURL = type;
      } else if (type === "home-calendar") {
        sessionStorage.setItem("fromMessagecentre", "false");
  
        this.supportService.headerSubLittle.next("Home");
        this.currentURL = "home-calendar";
      } else if (
        type === "technician-schedule" ||
        type === "work-hours" ||
        type === "vacation-management" ||
        type === "vacation-history"
      ) {
        sessionStorage.setItem("fromMessagecentre", "false");
  
        this.supportService.headerSubLittle.next("Technologist Management");
        this.currentURL = "technician-schedule";
      } else if (
        type === "report-log" ||
        type === "insurance-billing" ||
        type === "checked-in-patient" ||
        type === "noshow-patient" ||
        type === "cancelled-report"
      ) {
        sessionStorage.setItem("fromMessagecentre", "false");
        this.currentURL = "report-log";
      } else if (type === "message-center") {
        this.currentURL = "message-center";
        sessionStorage.setItem("fromMessagecentre", "false");
      }

    } else {
      this.router.navigate(["/login"]);
    }

    
    this.sidemenuToggle.emit((this.showhideSideMenu = false));
  }

  toggleSidemenu() {
    this.sidemenuToggle.emit((this.showhideSideMenu = false));
  }
}
